import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, Method} from "axios";
import {API_URL} from "common/const";
import UnauthorizedError from "api/errors/UnauthorizedError";


export const fetchApiClient = (token?: string): AxiosInstance => {

    const defaultOptions = {
        baseURL: API_URL,
        method: "get" as Method,
        headers: {
            "Content-Type": "application/json",
        },
    };

    // Create instance
    const instance = axios.create(defaultOptions);

    // Set the AUTH token for any request, but only when one is available.
    // The previous code wrote the literal string "undefined" whenever token
    // was undefined, which the backend treats as a malformed auth header.
    instance.interceptors.request.use((config: AxiosRequestConfig) => {
        if (token && config.headers) {
            config.headers["x-auth-token"] = token;
        }
        return config;
    });

    // Centralized 403 → UnauthorizedError mapping. Every callsite used to do
    // this themselves with `if (error.response?.status === 403) throw new
    // UnauthorizedError()`. Keeping it here means (a) new endpoints can't
    // forget to do the mapping, and (b) we fix getMemberships which was
    // previously throwing RetryableError for 403 (§4.2 of the review).
    //
    // Per-endpoint handlers for other status codes (401 for wrong password,
    // 409 for conflicts, 428 for missing-synonyms, ...) keep running after
    // this interceptor because they live in each file's .catch() and only
    // fire for non-403 responses.
    instance.interceptors.response.use(
        (response) => response,
        (error: AxiosError) => {
            if (error.response?.status === 403) {
                throw new UnauthorizedError();
            }
            throw error;
        }
    );

    return instance;
};
